import React, { useCallback } from 'react';

import { GeoBlock } from '../../../components/GeoBlock';
import { useOfferContext } from '../../../context';
import { isCommercial } from '../../../utils/computedProps/commercial/isCommercial';
import { HighwayContainer } from '../HighwayContainer';
import { JKNameContainer } from '../JKNameContainer';
import { RailwayContainer } from '../RailwayContainer';
import { SeoSuggestionContainer } from '../SeoSuggestionContainer';
import { UndergroundContainer } from '../UndergroundContainer';
import { CommercialAddressContainer } from '../commercial/CommercialAddressContainer';

export function GeoContainer() {
  const { offer, geoLabels, tracking } = useOfferContext();

  const handleLabelClick = useCallback(
    (label: string, geoType: string) => {
      tracking.trackAddressClick({ label, geoType });
    },
    [tracking.trackAddressClick],
  );

  const commercial = isCommercial(offer);

  return (
    <GeoBlock geoLabels={geoLabels} onLabelClick={handleLabelClick} seoSuggestion={<SeoSuggestionContainer />}>
      {commercial ? <CommercialAddressContainer /> : <JKNameContainer />}
      <HighwayContainer />
      <UndergroundContainer />
      <RailwayContainer />
    </GeoBlock>
  );
}
